export enum ERequestManager {
  NONE = 'NONE',
  FETCHING = 'FETCHING',
  COMPLETED = 'COMPLETED',
}
